import React from "react";
import { Mutation } from "react-apollo";
import { ApolloProvider } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";

const CREATE_INTERESTED_SELLER_INQUIRY = gql`
  mutation createInterestedSellerInquiry(
    $callPreference: Boolean
    $email: String!
    $emailPreference: Boolean
    $entityId: ID
    $entityType: InterestedSellerInquiryEntityType
    $name: String!
    $notes: String
    $phone: String!
    $source: InterestedSellerInquirySource!
    $textPreference: Boolean
  ) {
    create_interested_seller_inquiry(
      input: {
        call_preference: $callPreference
        email: $email
        email_preference: $emailPreference
        entity_id: $entityId
        entity_type: $entityType
        name: $name
        notes: $notes
        phone: $phone
        source: $source
        text_preference: $textPreference
      }
    ) {
      id
    }
  }
`;

const withCreateSellerInquiry = Component => props => (
  <ApolloProvider client={apolloClient}>
    <Mutation mutation={CREATE_INTERESTED_SELLER_INQUIRY}>
      {createInterestedSellerInquiry => (
        <Component
          {...props}
          createInterestedSellerInquiry={createInterestedSellerInquiry}
        />
      )}
    </Mutation>
  </ApolloProvider>
);

export default withCreateSellerInquiry;
